import { Injectable } from '@angular/core';
import { map, merge, Subject } from 'rxjs';
import { SocketService } from '@services/webFeeder/socket.service';
import { ConfigService } from '@services/webFeeder/config.service';
import { StatusConnection } from '@model/status-connection';
import { MessageWebFeeder } from '@model/webFeeder/message-web-feeder.model';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StatusDifusionService {

  public messagesStatusDifusion: Observable<any>;
  private serviceSubject = new Subject<MessageEvent>();
  public showStatusSuccess = true;

  constructor(
    private socketService: SocketService,
    private configService: ConfigService
  ) { }


  public createSubject() {
    const newService = {
      name: 'StatusDifusionSvcByFn', serviceSubject: this.serviceSubject,
      fn: (data) => {
        return data && data.statusDifusion;
      }
    };
    this.socketService.register(newService);
    const statusWFError = this.socketService._statusWFOnError$;
    const message = newService.serviceSubject;
    this.messagesStatusDifusion = merge(message, statusWFError).pipe(map(data => {
      let status;
      if (data['statusDifusion'] === 'serving') {
        if (this.showStatusSuccess) {
          this.configService.writeLog('STATUS DIFUSION: Conectado');
          this.showStatusSuccess = false;
        }
        status = StatusConnection.SUCCESS;
      } else if (data['statusDifusion'] === 'stop' || data['statusDifusion'] === 'close') {
        let maxConnection = data['connections'].length - 1;
        data['connections'].forEach(element => {
          if (element.status === 'connected') {
            if (maxConnection < data['connections'].length) {
              maxConnection++;
            }
          } else {
            maxConnection--;
          }
        });
        this.configService.writeLog('STATUS DIFUSION: Servidores ON: ' + maxConnection + ' - TOTAL: ' + data['connections'].length);
        if (maxConnection <= 0) {
          status = StatusConnection.ERROR;
          this.configService.writeLog('STATUS DIFUSION: Desconectado');
          this.showStatusSuccess = true;
        } else {
          status = StatusConnection.WARNING;
          this.configService.writeLog('STATUS DIFUSION: Alerta');
          this.showStatusSuccess = true;
        }
      } else if (data == StatusConnection.INITIAL) {
        this.configService.writeLog('STATUS DIFUSION: Iniciando');
        this.showStatusSuccess = true;
        status = StatusConnection.SUCCESS;
      } else if (data == StatusConnection.ERROR) {
        this.configService.writeLog('STATUS DIFUSION: Desconectado');
        this.showStatusSuccess = true;
        status = StatusConnection.ERROR;
      } else {
        status = StatusConnection.WARNING;
        this.configService.writeLog('STATUS DIFUSION: Reconectando');
        this.showStatusSuccess = true;
      }
      return status;
    }));
  }

  public subscribeDifusion(componentName: string) {
    this.configService.writeLog('<<<< SUBSCRIBE STATUS DIFUSION [' + (componentName ? componentName.toUpperCase() : null) + '] >>>>');
    this.sendMessageStatusDifusion(true);
  }
  public unsubscribeDifusion(componentName: string) {
    this.sendMessageStatusDifusion(false);
    this.configService.writeLog('<<<< UNSUBSCRIBE TATUS DIFUSION [' + (componentName ? componentName.toUpperCase() : null) + '] >>>>');
  }

  private sendMessageStatusDifusion(status: boolean) {
    const dataMsg: MessageWebFeeder = new MessageWebFeeder();
    dataMsg.token = this.configService.getToken();
    dataMsg.module = 'quotes';
    dataMsg.service = 'statusDifusion';
    dataMsg.parameters = { 'dispatch': status };
    setTimeout(() => {
      this.socketService.signService(dataMsg);
    }, 1000);
  }

}
